var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completed-orders"},[_c('base-status-orders',{attrs:{"status":'COMPLETED',"title":'已完成订单',"show-actions":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }